export const callStatusTypes  = {
    QUEUED: "queued",
    INITIATED: "initiated",
    IN_PROGRESS: "in_progress",
    ANSWERED: "answered",
    COMPLETED: "completed",
    FAILED: "failed",
    REFERRED_COMPLETED: "referred_completed"
}
